import { SxProps } from '@mui/material';
import { globalLayout, lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  mainContainer: {
    backgroundColor: palette.primary['50'],
    width: '100%'
  },

  contentContainer: {
    ...globalLayout,
    maxWidth: '120rem'
  },

  headingTitle: {
    color: palette.primary.main,
    mb: spacing(1)
  },

  // cardStyles
  card: {
    width: '100%',
    maxWidth: {
      md: '19.25rem'
    },
    display: 'block',
    position: 'relative',
    cursor: 'pointer',
    textDecoration: 'none',

    '&:hover': {
      '.content': {
        background: palette.primary.main
      },

      '.title': {
        color: palette.grey['50']
      },

      '.subtitle': {
        color: palette.secondary.main
      },

      '.year': {
        color: palette.secondary.main
      },

      '.arrowIcon': {
        svg: {
          path: {
            stroke: palette.secondary.main
          }
        }
      }
    }
  },
  cardImg: {
    height: '8.125rem',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    position: 'relative'
  },
  content: {
    padding: spacing(1),
    background: palette.primary['400'],
    height: '10.5rem'
  },
  title: {
    fontWeight: '500',
    color: palette.grey.main,
    width: '100%'
  },
  subtitle: {
    fontWeight: '400',
    color: palette.grey['400'],
    width: '100%',
    my: spacing(0.5)
  },
  year: {
    fontWeight: '400',
    color: palette.grey['400'],
    width: '100%'
  },
  bottomIcon: {
    position: 'absolute',
    right: spacing(1),
    bottom: spacing(0.5)
  },
  arrowIcon: {
    svg: {
      path: {
        stroke: palette.primary.main
      }
    }
  }
};

export default styles;
